import React from "react";

import "normalize.css";

import AppleMusic from "./apple_music/AppleMusic.js";
import ErrorBoundary from "./apple_music/ErrorBoundary.js";

class AppleMusicContainer extends React.Component {
  constructor(props) {
    super(props);
    console.log("AppleMusicContainer: constructor");
  }

  render() {
    return (
      <ErrorBoundary>
        <AppleMusic {...this.props} />
      </ErrorBoundary>
    );
  }
}

export default AppleMusicContainer;
